import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { memo } from "react";
import { flex } from "shared/theme/mixins";

const SpaceBetweenCenter = styled(Box)`
  ${flex({ jc: "space-between", ai: "center" })};
`;

export default memo(SpaceBetweenCenter);
